import React from 'react';
import { Col, Row } from 'react-bootstrap5';

import { useContext } from 'components/Managers/Dashboard/Context';
import useCpaTopStrengths from 'components/Managers/Dashboard/Hooks/useCpaTopStrengths';
import useCpaTeamProfile from 'components/Managers/Dashboard/Hooks/useCpaTeamProfile';
import useCpaStatistics from 'components/Managers/Dashboard/Hooks/useCpaStatistics';
import TopStrengths from './TopStrengths';
import TeamProfile from './TeamProfile';
import Statistics from './Statistics';

export default function Index() {
  const { state: { filters } } = useContext();

  const { data: cpaTopStrengths, loading: loadingTopStrengths } = useCpaTopStrengths(filters);
  const { data: cpaTeamProfile, loading: loadingTeamProfile } = useCpaTeamProfile(filters);
  const { data: cpaStatistics, loading: loadingStatistics } = useCpaStatistics(filters);

  return (
    <>
      <h3 className="mb-3">Productivity</h3>

      <Row>
        <Col lg="4" className="mb-2 mb-lg-0">
          <TopStrengths
            data={loadingTopStrengths ? null : cpaTopStrengths.productivity}
            variant="primary"
          />
        </Col>

        <Col lg="4" className="mb-2 mb-lg-0">
          <TeamProfile
            data={loadingTeamProfile ? null : cpaTeamProfile.productivity}
            variant="primary"
          />
        </Col>

        <Col lg="4" className="mb-2 mb-lg-0">
          <Statistics
            data={loadingStatistics ? null : cpaStatistics.productivity}
            variant="primary"
          />
        </Col>
      </Row>

      <h3 className="mt-5 mb-3">Wellbeing</h3>

      <Row>
        <Col lg="4" className="mb-2 mb-lg-0">
          <TopStrengths
            data={loadingTopStrengths ? null : cpaTopStrengths.wellbeing}
            variant="secondary"
          />
        </Col>

        <Col lg="4" className="mb-2 mb-lg-0">
          <TeamProfile
            data={loadingTeamProfile ? null : cpaTeamProfile.wellbeing}
            variant="secondary"
          />
        </Col>

        <Col lg="4" className="mb-2 mb-lg-0">
          <Statistics
            data={loadingStatistics ? null : cpaStatistics.wellbeing}
            variant="secondary"
          />
        </Col>
      </Row>
    </>
  );
}
